import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { QrBarcodeScanner } from "../../../../components/common/QrBarcodeScanner/QrBarcodeScanner";
import { makeStyles } from "@material-ui/core/styles";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { DeleteIcon } from "../../../../components/common/iconography";
import { beep } from "../../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    padding: theme.spacing(2),
  },
  closeButton: {
    cursor: "pointer",
  },
  dialogActions: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
  },
}));

export const RelocateBarcodeScan = ({
  open,
  onClose,
  onSave,
  barcodeList,
  setBarcodeList,
}) => {
  const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const smUp = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const classes = useStyles();

  const [manualInput, setManualInput] = useState("");

  const handleSuccess = (barcode) => {
    beep(100, 520, 200);
    const newItem = {
      value: barcode,
    };
    setBarcodeList((prev) => [newItem, ...prev]);
  };

  const handleTempBarcodeChange = (e) => {
    const input = e.target.value;
    const alphanumericOnly = input.replace(/[^a-z0-9]/gi, "").toUpperCase();
    setManualInput(alphanumericOnly);
  };

  const handleAddBarcode = () => {
    const cleanedValue = manualInput.trim().toUpperCase();
    const newItem = {
      value: cleanedValue,
    };
    setBarcodeList((prev) => [newItem, ...prev]);
    setManualInput("");
  };

  const handleSave = () => {
    if (barcodeList.length === 0) {
      onClose();
      return;
    }
    const result = barcodeList.map((value) => ({ value }));
    onSave(result);
    onClose();
  };

  const handleRemoveBarcode = (value) => {
    setBarcodeList((prev) => prev.filter((item) => item.value !== value));
  };

  const handleClear = () => {
    setBarcodeList([]);
    setManualInput("");
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      fullScreen={smDown}
      classes={{ paper: classes.dialogPaper }}
    >
      <Box
        component="span"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        m={2}
      >
        <Typography variant="h6">
          Scan Barcode{" "}
          <Typography
            component="span"
            variant="subtitle2"
            style={{ marginLeft: 6 }}
          >
            ({barcodeList.length} scanned)
          </Typography>
        </Typography>
        <CancelOutlinedIcon fontSize="large" onClick={handleClose} />
      </Box>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <QrBarcodeScanner onScanSuccess={handleSuccess} />
          </Grid>
          <Grid item xs={12} container spacing={1} alignItems="center">
            <Grid item xs>
              <TextField
                label="Barcode"
                variant="outlined"
                fullWidth
                margin="dense"
                value={manualInput}
                onChange={handleTempBarcodeChange}
              />
            </Grid>
            <Grid item>
              {smUp ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddBarcode}
                  startIcon={<AddCircleIcon />}
                >
                  ADD
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddBarcode}
                >
                  <AddCircleIcon />
                </Button>
              )}
            </Grid>
            <Grid item xs={12} className={classes.scrollableContainer}>
              {barcodeList.map((item, index) => (
                <Grid
                  container
                  key={index}
                  item
                  spacing={1}
                  alignItems="center"
                >
                  <Grid item xs>
                    <Typography>{item.value}</Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      className={classes.removeIcon}
                      onClick={() => handleRemoveBarcode(item.value)}
                      color="secondary"
                    >
                      <DeleteIcon />
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClear}>Clear</Button>
        <Box sx={{ flex: 1 }} />
        <Button onClick={handleSave}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
